import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Segment, Menu, Button, Grid } from 'semantic-ui-react';
import { addLogin } from '../../actions/AppActions';

import { Link } from 'react-router-dom';

import './HeaderComponent.css';
import { translate } from 'react-translate';
import { compose } from 'redux';
import { connect } from 'react-redux';
import FilAriane from './FilAriane';
import Etape from './Etape';

import { isSignedIn, onSignOut } from '../../Auth';
import LoginComponent from '../Login/LoginComponent';

class HeaderComponent extends Component {
  static propTypes = {
    addSelectedUserType: PropTypes.func,
    addLogin: PropTypes.func,
  };
  
  constructor(props) {
    super(props);
    this.state = {
      displayLogin: false,
    };
  }

  signOut() {
    onSignOut().then(window.location = '/');
  }

  handleLogin = () => {
    const { displayLogin } = this.state;
    this.setState({ displayLogin: !displayLogin });
  }

  render() {
    const { commonState, history, t, app: { env }, currentPage } = this.props;
    const { displayLogin } = this.state;
    return (
      <Segment raised id="blocHeader">
        { displayLogin && (
          <LoginComponent
            open={displayLogin}
            onClose={() => this.handleLogin()}
          />
        )}
        <Grid verticalAlign="middle" padded>
          <FilAriane />

          {isSignedIn()
            ? (
              <Link to="/">
                <Button basic onClick={this.signOut} id="seDecoBtn">
                  {t('logout')}
                </Button>
              </Link>
            ) : (
              <Button basic onClick={() => this.handleLogin()} id="seDecoBtn">
                {t('login')}
              </Button>
            )
          }
        </Grid>
        <Etape
          currentPage={currentPage}
          commonState={commonState}
          history={history}
          env={env}
        />
      </Segment>
    );
  }
}

const maptStatToProps = state => ({
  app: state.app,
  addLogin,
});

export default compose(connect(maptStatToProps), translate('HeaderComponent'))(HeaderComponent);



// WEBPACK FOOTER //
// ./src/components/shared/HeaderComponent.jsx